import {PaletteColorsEnum} from '../../../../core/src/models/api/paletteModel';
import {colorPrimitive} from '../../styles/primitives/colorPrimitive';

interface MetricColorStyle {
  primary: string;
  secondary: string;
}
interface MetricColorWithShadeStyle extends MetricColorStyle {
  '001': string;
  'text-001': string;
  '002': string;
  'text-002': string;
  '003': string;
  'text-003': string;
  '004': string;
  'text-004': string;
  '005': string;
  'text-005': string;
}

export type MetricColorWithoutShade =
  | PaletteColorsEnum.ORANGE
  | PaletteColorsEnum.PINK
  | PaletteColorsEnum.YELLOW
  | PaletteColorsEnum.TEAL
  | PaletteColorsEnum.GREEN
  | PaletteColorsEnum.RED
  | PaletteColorsEnum.GREY;

export type MetricColorWithShade = PaletteColorsEnum.BLUE;

export type MetricColor = MetricColorWithoutShade | MetricColorWithShade;

export interface MetricsSemanticStyles
  extends Record<MetricColorWithoutShade, MetricColorStyle>,
    Record<MetricColorWithShade, MetricColorWithShadeStyle> {}

export const lightMetricsSemanticStyles = {
  [PaletteColorsEnum.BLUE]: {
    primary: colorPrimitive.blue[500],
    secondary: colorPrimitive.blue[300],
    '001': colorPrimitive.blue[200],
    'text-001': colorPrimitive.blue[700],
    '002': colorPrimitive.blue[300],
    'text-002': colorPrimitive.blue[700],
    '003': colorPrimitive.blue[500],
    'text-003': colorPrimitive.blue[100],
    '004': colorPrimitive.blue[700],
    'text-004': colorPrimitive.blue[100],
    '005': colorPrimitive.blue[800],
    'text-005': colorPrimitive.blue[100],
  },
  [PaletteColorsEnum.ORANGE]: {
    primary: colorPrimitive.orange[500],
    secondary: colorPrimitive.orange[300],
  },
  [PaletteColorsEnum.PINK]: {
    primary: colorPrimitive.magenta[500],
    secondary: colorPrimitive.magenta[300],
  },
  [PaletteColorsEnum.YELLOW]: {
    primary: colorPrimitive.yellow[500],
    secondary: colorPrimitive.yellow[300],
  },
  [PaletteColorsEnum.TEAL]: {
    primary: colorPrimitive.teal[500],
    secondary: colorPrimitive.teal[300],
  },
  [PaletteColorsEnum.GREEN]: {
    primary: colorPrimitive.green[500],
    secondary: colorPrimitive.green[300],
  },
  [PaletteColorsEnum.RED]: {
    primary: colorPrimitive.red[600],
    secondary: colorPrimitive.red[300],
  },
  [PaletteColorsEnum.GREY]: {
    primary: colorPrimitive.gray[500],
    secondary: colorPrimitive.gray[300],
  },
} as const satisfies MetricsSemanticStyles;

export const redesignedLightMetricsSemanticStyles = {
  ...lightMetricsSemanticStyles,
  [PaletteColorsEnum.BLUE]: {
    primary: colorPrimitive.blurple[500],
    secondary: colorPrimitive.blurple[300],
    '001': colorPrimitive.blurple[200],
    'text-001': colorPrimitive.blurple[700],
    '002': colorPrimitive.blurple[300],
    'text-002': colorPrimitive.blurple[700],
    '003': colorPrimitive.blurple[500],
    'text-003': colorPrimitive.blurple[100],
    '004': colorPrimitive.blurple[700],
    'text-004': colorPrimitive.blurple[100],
    '005': colorPrimitive.blurple[800],
    'text-005': colorPrimitive.blurple[100],
  },
} as const satisfies MetricsSemanticStyles;

export const darkMetricsSemanticStyles = {
  [PaletteColorsEnum.BLUE]: {
    primary: colorPrimitive.blue[500],
    secondary: colorPrimitive.blue[800],
    '001': colorPrimitive.blue[900],
    'text-001': colorPrimitive.blue[400],
    '002': colorPrimitive.blue[800],
    'text-002': colorPrimitive.blue[400],
    '003': colorPrimitive.blue[600],
    'text-003': colorPrimitive.blue[100],
    '004': colorPrimitive.blue[400],
    'text-004': colorPrimitive.blue[100],
    '005': colorPrimitive.blue[300],
    'text-005': colorPrimitive.blue[700],
  },
  [PaletteColorsEnum.ORANGE]: {
    primary: colorPrimitive.orange[600],
    secondary: colorPrimitive.orange[800],
  },
  [PaletteColorsEnum.PINK]: {
    primary: colorPrimitive.magenta[600],
    secondary: colorPrimitive.magenta[800],
  },
  [PaletteColorsEnum.YELLOW]: {
    primary: colorPrimitive.yellow[600],
    secondary: colorPrimitive.yellow[800],
  },
  [PaletteColorsEnum.TEAL]: {
    primary: colorPrimitive.teal[600],
    secondary: colorPrimitive.teal[800],
  },
  [PaletteColorsEnum.GREEN]: {
    primary: colorPrimitive.green[600],
    secondary: colorPrimitive.green[800],
  },
  [PaletteColorsEnum.RED]: {
    primary: colorPrimitive.red[600],
    secondary: colorPrimitive.red[800],
  },
  [PaletteColorsEnum.GREY]: {
    primary: colorPrimitive.gray[600],
    secondary: colorPrimitive.gray[800],
  },
} as const satisfies MetricsSemanticStyles;

export const redesignedDarkMetricsSemanticStyles = {
  ...darkMetricsSemanticStyles,
  [PaletteColorsEnum.BLUE]: {
    primary: colorPrimitive.blurple[500],
    secondary: colorPrimitive.blurple[800],
    '001': colorPrimitive.blurple[900],
    'text-001': colorPrimitive.blurple[400],
    '002': colorPrimitive.blurple[800],
    'text-002': colorPrimitive.blurple[400],
    '003': colorPrimitive.blurple[600],
    'text-003': colorPrimitive.blurple[100],
    '004': colorPrimitive.blurple[400],
    'text-004': colorPrimitive.blurple[100],
    '005': colorPrimitive.blurple[300],
    'text-005': colorPrimitive.blurple[700],
  },
} as const satisfies MetricsSemanticStyles;
